import { useMemo } from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import type { PetitionUpdatesList, PetitionUpdatesQueryState } from '#src/app/pages/petitionDetails/shared/types';
import { isLoaded } from '#src/app/shared/utils/async';

import { extractDisplayedUpdates } from './extractDisplayedUpdates';

export function useDisplayedUpdates(updatesState: PetitionUpdatesQueryState): PetitionUpdatesList {
	const {
		data: {
			petition: {
				signatureState: {
					signatureCount: { displayed },
				},
			},
		},
	} = usePetitionDetailsPageData();

	return useMemo(() => {
		if (!isLoaded(updatesState)) {
			return [];
		}
		return extractDisplayedUpdates(updatesState.updates, displayed);
	}, [updatesState, displayed]);
}
